import { PageEvent } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';
import { BehaviorSubject } from 'rxjs';

// NEW V2 INTERFACE
interface FixedPriceOutput {
  value: number;
}

interface DynamicPriceOutput {
  low: number;
  high: number;
}

interface PriceOutputs {
  fixed: FixedPriceOutput | null;
  dynamic: DynamicPriceOutput | null;
}

interface ConnectorInfo {
  connectorCount: number;
  connectorCountDefaultPricePolicy: number;
}

export enum PricePolicyType {
  FixedWithoutOkMeter = 'FixedWithoutOkMeter',
  FixedWithOkMeter = 'FixedWithOkMeter',
  Dynamic = 'Dynamic',
}

export interface PricePolicy {
  id: number;
  name: string;
  type: PricePolicyType;
  basePriceInKrWithoutVat: PriceOutputs;
  organizationId: number | null;
  organizationName: string | null;
  connectorInfo: ConnectorInfo;
  fallbackPricePolicyId: number | null;
  okSupplementInKrWithoutVat: number | null;
  organizationSupplementInKrWithoutVat: number | null;
  deleted?: boolean;
  consumerPriceInKrWithVat: PriceOutputs;
  highlight: BehaviorSubject<boolean>;
}

export class PricePolicySearchEvent {
  constructor(paging: PageEvent) {
    this.organizationId = null;
    this.query = null;
    this.onlyGlobal = false;
    this.includeGlobal = false;
    this.alwaysIncludeDynamic = false;
    this.paging = paging;
    this.sorting = null;
    this.pricePolicyId = null;
    this.type = null;
  }
  organizationId: number | null;
  query: string | null;
  onlyGlobal = false;
  includeGlobal = false;
  alwaysIncludeDynamic = false;
  paging: PageEvent;
  sorting: Sort | null;
  pricePolicyId: number | null;
  type: string | null;
}
